module.exports = __webpack_public_path__ + "img/forestorytellingtour_option_02.613c134b.jpg";